const RouteName = Object.freeze({
  PARTICIPANT_ASSIGNMENT: 'Participant Assignment',
  PARTICIPANT_CONTACT: 'Participant Contact'
});

export {RouteName}




// WEBPACK FOOTER //
// ./src/enums/routeName.js